module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 41
// module chunks = 0